import Vue from 'vue';
export const EventBus = new Vue();

import onAppMount from './eventbus/onAppMount';
import onWebsocketOpen from './eventbus/onWebsocketOpen';

export const listeners = {
  onAppMount: onAppMount(EventBus),
  onWebsocketOpen: onWebsocketOpen(EventBus),
};
